import InstantWeather from './InstantWeather.component';

export default InstantWeather;